import React from "react";

const Policy = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <p className="text-dark fw-semibold opacity-50 mb-0">
              Effective Date: 10/08/2025
            </p>
            <p className="text-dark fw-semibold opacity-50 mb-0">
              Company: TopCoin UK. Ltd
            </p>
            <p className="text-dark fw-semibold opacity-50 mb-0">
              Company Registeration No: 16483297
            </p>
            <p className="text-dark fw-semibold opacity-50 mb-3">
              Contact: info@topcoinuk.com
            </p>

            <ul className="list-unstyled">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">1. Introduction</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  Topcoin UK Ltd (“we”, “our”, “us”) values your privacy. This
                  Privacy Policy explains how we collect, use, store, and
                  protect your personal information when you use our website,
                  services, and our wallet-based reward system.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  By using our site and services, you agree to the terms of this
                  Privacy Policy.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  2. What Information We Collect
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Name & Email Address: Used to create your wallet and manage
                  your account.{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Wallet ID & Transaction Data: Used to track Topcoin UK and
                  rewards.{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Cookies & Analytics Data: Used to improve our website,
                  monitor usage, and enhance security.{" "}
                </p>

                <p className="info_description text-dark opacity-50 mb-0">
                  We do not collect additional personal details such as physical
                  addresses, payment information, or sensitive data.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  3. How We Use Your Information
                </h5>

                <p className="info_description text-dark opacity-50 mb-0">
                  {" "}
                  - Create and manage your wallet.{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Provide customer support and respond to inquiries.
                  <p className="info_description text-dark opacity-50 mb-0">
                    - Maintain security and prevent fraud.{" "}
                  </p>
                  <p className="info_description text-dark opacity-50 mb-0">
                    - Improve our website and services.{" "}
                  </p>
                  <p className="info_description text-dark opacity-50 mb-0"></p>
                  - Comply with legal and regulatory requirements.
                </p>

                <p className="text-dark opacity-50 ">
                  We do not sell, rent, or trade your personal information to
                  third parties.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  4. Wallet & Platform Data
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  Your Topcoin UK wallet is part of our internal platform
                  system. Wallet IDs and transaction histories are securely stored on our
                  protected servers. These records do not contain personal identifying
                  information beyond the wallet ID.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">5. Cookies </h5>
                <p className="info_description text-dark opacity-50 fw-bold mb-0">
                  Our website uses cookies to:
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  {" "}
                  - Save your preferences and login sessions.{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Analyze website traffic through analytics tools.{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Improve overall user experience.
                </p>
              </li>
              {/* <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  6. Children & Under-18 Users{" "}
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  Topcoin UK allows users under 18 to participate in the wallet
                  system. We collect only minimal data (name and email) to
                  create wallets. Parents and guardians are encouraged to
                  monitor their child’s online activity.
                </p>
              </li> */}
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">6. Data Security </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  We implement strong technical and organizational measures to
                  safeguard your data, including:{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Encrypted storage of wallet data.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Secure servers with restricted access.{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Regular security audits and updates.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">7. Data Retention </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Wallet and transaction data are retained as long as your
                  account is active.{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Emails and account details are kept only while you use our
                  services or as required by law.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  8. Your Rights (UK GDPR){" "}
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  Under the UK GDPR and Data Protection Act 2018, you have the
                  right to:
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Access your personal data.{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Correct inaccurate data.{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Request deletion of your data.{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Object to certain processing.{" "}
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  - Request a copy of your data (data portability).
                </p>

                <p className="info_description text-dark opacity-50 mb-0">
                  To exercise these rights, contact us at info@topcoinuk.com.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  9. Third-Party Services
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  We may use trusted third-party services (e.g., analytics,
                  hosting). These services comply with UK GDPR and only process
                  data necessary to provide their service.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  10. Changes to This Policy
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  We may update this Privacy Policy to reflect changes in our
                  services or legal requirements. Updates will be posted on this
                  page with a new effective date.
                </p>
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                  className="py-2"
                >
                  <h5 className="title_text text-dark">
                    11. Legal Disclaimer{" "}
                  </h5>
                  <p className="info_description text-dark opacity-50 mb-0">
                    Topcoin UK Ltd reserves the right to amend, update, or
                    modify these Rules and Regulations at any time without prior
                    notice. Continued participation in the Topcoin UK programme
                    constitutes full acceptance of all current and future terms
                    and conditions.
                  </p>
                </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">12. Contact Us</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  For questions about this Privacy Policy, contact us
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  info@topcoinuk.com
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Policy;
